import {  Link } from "react-router-dom"

import SVHeaderItem from './SVHeaderItem'
import {StaticRouter} from 'react-router'
/*
import TacosContainerPage from '../../views/TacosContainerPage'
*/


//import {LoginabodeContainerCom} from '../../containers'

const React = require('react')
const {noop} = StaticRouter
/*
function TacosListPage(){
    return <h3>Tacos List Page</h3>;
  
  }
  function Bus() {
    return <h3>Bus</h3>;
  }
  */
export  class SVFancyNav extends React.Component{

    constructor(props){
        super(props)
        let me = this
        this.navClick = this.navClick.bind(this)
        this.headerUL = this.headerUL.bind(me)
        this.headerItems = this.headerItems.bind(me)
        this.state={
            svClassValue:{
               0 :'active',
               1:'',
               2:'',
               3:'',
               4:''
            }
        }

    }

navClick(event){
    console.log('nav click')
    console.log(event.target.value)
}
headerUL(mychilds){
    return (
        <ul className="nav nav-tabs nav-justified">
            <li><a href="/sv/r/apg/acctsumm">PerformanceFN & Value</a></li>
            {this.headerItems(mychilds)}

            </ul>
    )
}
headerItems(mychilds){
    return mychilds.map( (o,idx)=>{
        return (<SVHeaderItem to={o.path}>{o.label}</SVHeaderItem>)
    })
    
    return (
        <ul className="nav nav-tabs nav-justified">
        {/*
        <SVNavItem to="/svessearch" component={SVESSearchCom}> SV Abode </SVNavItem>
    
        */}
         <li><a href="/sv/r/apg/acctsumm">PerformanceFN & Value</a></li>
        
              <SVHeaderItem to="/tacos">TacosHeaderFN</SVHeaderItem>
        
       
            <SVHeaderItem to="/svlogin">SVMy ReservationsFN</SVHeaderItem>
        
    </ul>
    )
}
headerItemsHw(mychilds){
    return (
        <ul className="nav nav-tabs nav-justified">
        {/*
        <SVNavItem to="/svessearch" component={SVESSearchCom}> SV Abode </SVNavItem>
    
        */}
         <li><a href="/sv/r/apg/acctsumm">PerformanceFN & Value</a></li>
        
              <SVHeaderItem to="/tacos">TacosHeaderFN</SVHeaderItem>
        
       
            <SVHeaderItem to="/svlogin">SVMy ReservationsFN</SVHeaderItem>
        
    </ul>
    )
}
render(){
    /*
    let mychilds  = [
        {
          label:  "TacosListPagerFN",
          path: "/tacos/list",
          component: TacosListPage
        },
        {
            label:  "TacosContainerPagerFN",
          path: "/tacos/:id",
          component: TacosContainerPage
        },
        
        {
            label:  "BusFN",
          path: "/tacos/bus",
          component: Bus
        }
      ]
      */
     console.log(this.props)
     const {svparams:{mychilds}} = this.props
    const {headerItems, headerUL} = this
    return headerUL(mychilds)

}
    renderOld(){

        //const {nob} = this.props
       
        return (
            <ul className="nav nav-tabs nav-justified">
            {/*
            <SVNavItem to="/svessearch" component={SVESSearchCom}> SV Abode </SVNavItem>
        
            */}
             <li><a href="/sv/r/apg/acctsumm">PerformanceFN & Value</a></li>
            
                  <SVHeaderItem to="/tacos">TacosHeaderFN</SVHeaderItem>
            
           
                <SVHeaderItem to="/svlogin">SVMy ReservationsFN</SVHeaderItem>
            
        </ul>
        )
        
    }
}